import React from 'react';
import { Router, Route, Redirect, Switch } from 'react-router';
import history from '../history';
import LayoutContainer from '../containers/LayoutContainer';

class AppRouter extends React.Component {
    render() {
        return (
            <Router history={history}>
                <Switch>
                    <Route path={`/:lang([a-z]{2})`} component={LayoutContainer} />
                    <Redirect to="/de" />
                </Switch>
            </Router>
        );
    }
}

export default AppRouter;
